// extracted by mini-css-extract-plugin
module.exports = {"card":"packs_card__3TfQD","content":"packs_content___aY1C","media":"packs_media__16MMc"};